export enum RightsCases {
  createRequisition = "createRequisition",
  viewResource = "viewResource",
  cloudSettings="cloudSettings",
  viewClass="viewClass",
  deleteResource="deleteResource",
}